<template>
    <div
        v-if="isVisible"
        class="flex-1 flex items-center justify-center flex-col bg-white bg-opacity-50 active:outline-none z-50 fixed inset-0 "
    >
        <slot />
        <div class="text-center font-700">
            <span class="words-wrapper font-400">
                <b
                    v-for="(item, index) in textList"
                    :key="index"
                    :class="[step===index?'is-visible':'is-hidden']"
                >{{ item }}</b>
            </span>
        </div>
    </div>
</template>

<script>
import { ref, watch, onBeforeUnmount } from 'vue';

export default {
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        textList: {
            type: Array,
            default: () => [],
        }
    },
    setup(props) {
        const step = ref(0);
        const isVisible = ref(false);
        let setTime = null;
        const getStarted = () => {
            setTime = setTimeout(function () {
                if (step.value + 1 < 3) {
                    step.value++;
                } else {
                    step.value = 0;
                }
                if (isVisible.value) {
                    getStarted();
                }
            }, 3500);
        };

        onBeforeUnmount(() => {
            clearTimeout(setTime);
        });

        if (props.isLoading) getStarted();
        watch(() => props.isLoading, (nV) => {
            isVisible.value = nV;
            if (nV) {
                getStarted();
            };
        });

        return {
            step, isVisible
        };
    },
};
</script>

<style lang="scss" scoped>
.words-wrapper {
    display: inline-block;
    position: relative;
    text-align: center;

    b {
        opacity: 0;
        display: inline-block;
        position: absolute;
        white-space: nowrap;
    }

    .is-visible {
        position: relative;
        opacity: 1;
        -webkit-animation: push-in 0.5s;
        -moz-animation: push-in 0.5s;
        animation: push-in 0.5s;
    }

    .is-hidden {
        -webkit-animation: push-out 0.5s;
        -moz-animation: push-out 0.5s;
        animation: push-out 0.5s;
    }
}

@keyframes push-in {
    0% {
        opacity: 0;
        transform: translateY(-100%);
    }
    60% {
        opacity: 1;
        transform: translateY(10%);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}
@keyframes push-out {
    0% {
        opacity: 1;
        transform: translateY(0);
    }
    60% {
        opacity: 0;
        transform: translateY(110%);
    }
    100% {
        opacity: 0;
        transform: translateY(100%);
    }
}
</style>
